import { TaskType, RecurrenceType, TaskStatus, DeleteMode } from '../utils/interfaces';

export const TASK_TYPE_LABELS: Record<TaskType, string> = {
  DISOSTRUZIONE_ORIZZONTALE: 'Disostruzione orizzontale',
  DISOSTRUZIONE_VERTICALE: 'Disostruzione verticale',
  TRASPORTO_SMALTIMENTO: 'Trasporto e smaltimento',
  PULIZIA_SANIFICAZIONE: 'Pulizia e sanificazione',
  POMPE_SOLLEVAMENTO: 'Pompe di sollevamento',
  VERIFICA_COLLAUDO: 'Verifica e collaudo',
  ALTRO: 'Altro',
};

export const RECURRENCE_TYPE_LABELS: Record<RecurrenceType, string> = {
  DAILY: 'Giorno',
  WEEKLY: 'Settimana',
  MONTHLY: 'Mese',
  YEARLY: 'Anno',
};

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  DA_INIZIARE: 'Da iniziare',
  IN_CORSO: 'In corso',
  COMPLETATO: 'Completato',
};

export const DELETE_MODE_LABELS: Record<DeleteMode, string> = {
  ONLY_THIS: 'Solo questo intervento',
  THIS_AND_FUTURE: 'Questo e i successivi',
  ALL: 'Tutti gli interventi della serie',
};
